export default __webpack_public_path__ + "static/anzeige-vivawest-218a4c10788ace9b4abdbfcc070a6d5e.jpg";